import { connect } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'
import LegislationResultsItemSection from 'components/search/results-item/LegislationResultsItemSection'

const mapStateToProps = (state) => ({
  aol: state.aol.name,
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(LegislationResultsItemSection)
